<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
    <template #header>
      <Tabs v-model="tabName" @on-click="handleTab">
        <TabPane :label="$t('未报价')" name="NO" />
        <TabPane :label="$t('已报价')" name="YES" />
      </Tabs>
    </template>
    <template #detail="{ params, visible }">
      <detail ref="detail" :rows="params" v-if="visible"></detail>
    </template>
  </cTable>
</template>
<script>
import { getList, update, finance } from "@/api/order/miscellaneousQuotation";
import cTable from "@/base/common/index";
import { getSelectType } from "@/api/public";
// import { getAllClient, getCompanies } from "@/api/user/client";
// import { getCurrency } from "@/api/finance/currency";
// import { getAgent } from "@/api/tracker/agent";
import { getAllClient } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
// import { getChargingType } from "@/api/double/list";
// import { getConfig,getSubjectCost } from "@/api/tracker/cost_page";
import detail from "./detail";
export default {
  name: "miscellaneousQuotation",
  components: {
    cTable,
    detail,
  },
  async created() {
    this.status = (await getSelectType("INTERCEPT_STATUS")).data.payload[
      "INTERCEPT_STATUS"
    ];
    this.statusObj = this.status.reduce((a, b) => {
      a[b.value] = b.label;
      return a;
    }, {});
    // let agentList = (await getAgent()).data.payload.rows

    this.header.searchs.forEach(async (item) => {
      if (item.key === "status") item.options = this.status;
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "customer_service_id")
        item.options = (
          await getUser({ standard: "CustomerService" })
        ).data.payload.rows;
    });
    // this.modals.add.fields.forEach(t=>{
    // 	if(t.key === 'cod_agent')t.options = agentList
    // })
  },
  methods: {
    handleTab(tab) {
      // console.log(this);
      this.$refs["table"].tabName = this.tabName;
      this.$refs["table"].getList();
    },
  },
  data() {
    let that = this;
    return {
      tabName: "NO",
      status: [],
      statusObj: [],
      agentList: [],
      configs: {},
      client: [],
      companies: [],
      unit: [],
      bubble: [],
      currencyList: [],
      SubjectCost: [],
      methods: {
        getSelectType,
        list: (params) => {
          params["financeStatus"] = this.tabName;
          return getList(params);
        },
        update,
        finance,
      },
      modals: {
        detail: {
          methods: {
            ok: ({ close, row }) => {
              let detail = this.$refs["detail"].$refs["table"];
              let finance = detail.list;
              this.$refs["table"]
                .handleRequestMethods(
                  "finance",
                  { master_id: row.id, finance },
                  true,
                  true
                )
                .then((res) => {
                  close();
                });
            },
          },
          contentSlot: "detail",
          config: {
            title: this.$t("detail"),
            modalBind: {
              width: 70,
              top: "5%",
              draggable: true,
              sticky: true,
              styles: {
                top: "5%",
              },
            },
            // modalContentBind: {
            //   style: {
            //     height: "600px"
            //   }
            // }
          },
        },
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data.airway_number = data.airway_number.split("\n");
              this.$page
                .handleRequestMethods("update", data, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 700,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              status: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ status: 24 }, { airway_number: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$t("order_number"),
              key: "airway_number",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                type: "textarea",
                rows: 8,
              },
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 3,
              },
            },
            {
              key: "status",
              name: () => this.$t("tip"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("tip");
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.status;
                },
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "expense_item",
            placeholder() {
              return this.$tz("收费项目");
            },
            component: "Select",
            options: [],
            optionsFn: "expense",
            optionsKey: "",
          },
          {
            key: "bill_status",
            placeholder() {
              return this.$t("bill_type");
            },
            options: [
              { label: this.$tz("已出单"), value: 1 },
              { label: this.$tz("未出单"), value: 2 },
            ],
            component: "Select",
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("Customer");
            },
            config: { label: "account", value: "id" },
            options: [],
            component: "Select",
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("order_number");
            },
            bind: {
              type: "textarea",
              rows: 2,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("Update Status"),
            //   fnName: "updateStatus",
            //   type: "updateStatus",
            //   bind: {
            //     type: "primary",
            //   },
            // },
          ],
          methods: {
            updateStatus() {
              this.getModal("add").open(
                {
                  airway_number: this.selectAll
                    .map((t) => t.airway_number)
                    .join("\n"),
                },
                function () {
                  this.setTitle(this.$t("Update Status"));
                }
              );
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
        {
          name: this.$t("order_number"),
          key: "airway_number",
          minWidth: 120,
          header: {
            copy: true,
          },
        },
        {
          name: this.$t("b2bClient"),
          key: "account",
          minWidth: 120,
        },
        {
          name: () => this.$t("CollectionUser"),
          key: "target",
          minWidth: 100,
        },
        {
          name: this.$t("company_name"),
          key: "company",
          minWidth: 120,
        },
        {
          name: this.$t("salesman"),
          key: "sale_name",
          minWidth: 120,
        },
        {
          name: this.$t("bill_type"),
          key: "bill_status",
          minWidth: 120,
        },
        {
          name: this.$t("quotationStatus"),
          key: "finance_status",
          minWidth: 120,
        },
        {
          name: this.$t("quotationTime"),
          key: "finance_time",
          minWidth: 120,
        },
        {
          name: this.$t("Quotation Info"),
          key: "finance_info",
          minWidth: 120,
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("detail"),
              type: "detail",
              fnName: "detailFun",
              bind: {
                type: "success",
              },
              // id:1258
            },
          ],
          methods: {
            detailFun({ row }) {
              this.getModal("detail").open(row);
            },
          },
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped></style>
